enum ELookupAPIKeys {
	documentTypes = 'documenttypes',
	documentOwnerTypes = 'documentownertypes',
	unitOfMeasure = 'unitofmeasures'
}

export default ELookupAPIKeys;